<ng-container *ngIf="{
    subscriptionSpecializations: subscriptionSpecializations$ | async,
    subscriptionLocations: subscriptionLocations$ | async,
    subscribedSeniorityLevels: subscribedSeniorityLevels$ | async
  } as data">

<div class="subscription-edit">
    <span class="edit-subscription-header">{{'label.EditSubscription' | translate}}</span>
    <div class="subscription-details">
        <div class="subscription-details__specializations display-item">
            <div class="specializations__label display-item__label">{{'label.Specialties' | translate}}:</div>
            <div class="specializations__list display-item__list">
                <span *ngFor="let specialization of data.subscriptionSpecializations; let last=last;">
                    {{specialization.name}}{{last ? '' : '; '}}
                </span>
            </div>
        </div>
        <div  class="subscription-details__locations display-item">
            <div class="locations__label display-item__label">{{'label.Cities' | translate}}:</div>
            <div class="locations__list display-item__list">
                <span *ngFor="let location of data.subscriptionLocations; let last=last;">
                    {{location.name}}{{last ? '' : '; '}}
                </span>
            </div>
        </div>
        <div  class="subscription-details__seniority-levels display-item">
            <div class="seniority-levels__label display-item__label">{{'label.SeniorityLevel' | translate}}:</div>
            <div class="seniority-levels__list display-item__list">
                <span *ngFor="let seniorityLevel of data.subscribedSeniorityLevels; let last=last;">
                    {{seniorityLevel.name}}{{last ? '' : '; '}}
                </span>
            </div>
        </div>
    </div>
    <div class="button-container">
        <button class="subscription-edit__button" (click)="onEdit()">{{'label.Edit' | translate}}</button>
        <button *ngIf="(data.subscriptionLocations.length && data.subscriptionLocations.length > 0) || (data.subscriptionSpecializations.length && data.subscriptionSpecializations.length > 0) || (data.subscribedSeniorityLevels?.length && data.subscribedSeniorityLevels.length > 0)" class="subscription-cancel__button" (click)="onUnsubscribe()">{{'label.CancelSubscription' | translate}}</button>
    </div>
</div>

</ng-container>
